import { Download } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { MaskedLine, Reveal } from "@/components/Reveal";

export const LogoMark = ({ className = "" }) => (
  <span className={`font-oswald font-semibold lowercase tracking-[0.08em] whitespace-nowrap ${className}`}>
    <span className="text-[#F5F5F5]">onlyreviews</span>
    <span className="text-[#0055FF]">.</span>
    <span className="bg-gradient-to-r from-[#0055FF] to-[#FF3300] bg-clip-text text-transparent">blog</span>
  </span>
);

const Brand = () => (
  <main data-testid="brand-page">
    <Nav />
    <header className="pt-40 pb-16 px-6">
      <div className="max-w-4xl mx-auto">
        <p className="font-mono-p text-xs tracking-[0.35em] uppercase text-[#0055FF] mb-6">Brand Assets</p>
        <h1 className="font-serif-d text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight" data-testid="brand-page-title">
          <MaskedLine delay={0.2}>The onlyreviews.blog logo</MaskedLine>
        </h1>
        <p className="font-mono-p text-sm text-[#A1A1AA] mt-8 max-w-xl leading-relaxed">
          Download the official wordmark. Blue stands for Windows, orange for Macintosh —
          the gradient dot is where they meet.
        </p>
      </div>
    </header>

    <div className="max-w-5xl mx-auto px-6 pb-28 space-y-6">
      <Reveal>
        <div className="border border-white/10 bg-[#0A0A0A] p-12 md:p-20 flex items-center justify-center" data-testid="logo-preview-dark">
          <LogoMark className="text-4xl sm:text-6xl md:text-7xl" />
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="border border-white/10 bg-[#F5F5F5] p-12 md:p-20 flex items-center justify-center" data-testid="logo-preview-light">
          <span className="font-oswald font-semibold lowercase tracking-[0.08em] whitespace-nowrap text-4xl sm:text-6xl md:text-7xl">
            <span className="text-[#0A0A0A]">onlyreviews</span>
            <span className="text-[#0055FF]">.</span>
            <span className="bg-gradient-to-r from-[#0055FF] to-[#FF3300] bg-clip-text text-transparent">blog</span>
          </span>
        </div>
      </Reveal>

      <Reveal delay={0.15} className="flex flex-wrap gap-4 pt-4">
        <a
          href="/logo.svg"
          download="onlyreviews-blog-logo.svg"
          data-testid="download-logo-svg"
          className="flex items-center gap-3 font-oswald text-sm tracking-[0.25em] uppercase bg-[#F5F5F5] text-[#0A0A0A] px-8 py-4 hover:bg-[#0055FF] hover:text-white transition-colors duration-300"
        >
          <Download className="w-4 h-4" /> Download SVG
        </a>
        <a
          href="/logo.png"
          download="onlyreviews-blog-logo.png"
          data-testid="download-logo-png"
          className="flex items-center gap-3 font-oswald text-sm tracking-[0.25em] uppercase border border-white/20 px-8 py-4 hover:border-[#FF3300] hover:text-[#FF3300] transition-colors duration-300"
        >
          <Download className="w-4 h-4" /> Download PNG
        </a>
      </Reveal>
    </div>
    <Footer />
  </main>
);

export default Brand;
